import axios from 'axios'
import { getCurrentToken, getTokenContent, isDefined } from './common'

const API_URL = process.env.REACT_APP_API_URL

const request = axios.create({
  baseURL: API_URL,
  timeout: 30000,
})

request.interceptors.request.use(
  (config) => {
    const token = getCurrentToken()
    config.headers = {
      'X-LOCALIZATION-LANG': navigator.language.split('-')[0],
      ...config.headers,
    }
    if (isDefined(token)) {
      config.headers['Authorization'] = `Bearer ${token}`
      config.headers['factorId'] = getTokenContent(token).factorId
      config.headers['companyClientId'] = getTokenContent(token).companyClientId
      config.headers['isBroker'] = getTokenContent(token).isBroker
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    return response
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

export default request
